import { ERRO, INPUT, LABEL, TITULO } from './checkoutUi';

const CAMPOS = [
  {
    id: 'nome',
    label: 'Nome completo',
    type: 'text',
    placeholder: 'Nome completo da leitora',
    autoComplete: 'name',
  },
  {
    id: 'email',
    label: 'E-mail para acesso',
    type: 'email',
    placeholder: 'seuemail@exemplo.com',
    autoComplete: 'email',
  },
  {
    id: 'cpf',
    label: 'CPF',
    type: 'text',
    placeholder: '000.000.000-00',
    inputMode: 'numeric',
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp / celular',
    type: 'tel',
    placeholder: '(00) 00000-0000',
    autoComplete: 'tel',
  },
];

export default function DadosStep({
  dadosBase,
  handleInputChange,
  erros,
  statusUsuario,
}) {
  const inadimplente = statusUsuario?.situacao === 'inadimplente';
  const jaPago = statusUsuario?.situacao === 'ja_pago';

  return (
    <div className="flex flex-col gap-3 lg:gap-3.5">
      <h2 className={TITULO}>Seus dados</h2>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-x-4 lg:gap-y-3.5">
        {CAMPOS.map((c) => (
          <label key={c.id} className="flex flex-col gap-1.5">
            <span className={LABEL}>{c.label}</span>
            <input
              type={c.type}
              required
              value={dadosBase[c.id] || ''}
              onChange={(e) =>
                handleInputChange(c.id, e.target.value, 'dadosBase')
              }
              placeholder={c.placeholder}
              autoComplete={c.autoComplete}
              inputMode={c.inputMode}
              className={`${INPUT} ${c.id === 'cpf' && inadimplente ? '!border-red-400' : ''}`}
            />
            {erros?.[c.id] && (
              <span
                className={
                  c.id === 'cpf' && jaPago
                    ? 'text-[10px] font-bold text-emerald-600'
                    : ERRO
                }
              >
                {erros[c.id]}
              </span>
            )}
          </label>
        ))}
      </div>
    </div>
  );
}
